module.exports = __webpack_public_path__ + "static/media/tarjemle-logo.f00d1af8.png";